import script from "./BirthdayRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayRequest.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayRequest.vue?vue&type=style&index=0&id=50e27601&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e27601"]])

export default __exports__